function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 146.756,
  cy: 1021.76,
  r: 564,
  transform: "rotate(15 146.756 1021.76)",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1190.5,
  cy: 322.5,
  r: 249.5,
  transform: "rotate(43.2464 1190.5 322.5)",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 411,
  cy: 287,
  r: 53,
  transform: "rotate(180 411 287)",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 867.862,
  y1: 1802.77,
  x2: -378.462,
  y2: 671.611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.685105,
  stopColor: "white",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A4AB7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 1509.5,
  y1: 668,
  x2: 958.156,
  y2: 167.604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.685105,
  stopColor: "white",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A4AB7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 478.764,
  y1: 360.393,
  x2: 361.644,
  y2: 254.096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.685105,
  stopColor: "white",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A4AB7",
  stopOpacity: 0
})));

function SvgDashboardBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBackground);
export default __webpack_public_path__ + "static/media/dashboardBackground.ec5051afbfa0b750e250e067801b84d3.svg";
export { ForwardRef as ReactComponent };